var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "customcheckerboard-confirm-design"
  }, [_c('div', {
    staticClass: "customcheckerboard-confirm-design-body customcheckerboard-main-views-wrapper-body"
  }, [_c('h5', {
    class: ['customcheckerboard-confirm-design-title', 'text-center', 'customcheckerboard-main-views-wrapper-title', 'header--no-text-transform']
  }, [_vm._v("\n        " + _vm._s(_vm.translations.ugcConfirmDesc) + "\n    ")]), _vm.compositeImgKey ? _c('img', {
    staticClass: "customcheckerboard-confirm-design-image",
    attrs: {
      "src": _vm.imagesPreview[_vm.compositeImgKey].imgSrc,
      "alt": ""
    },
    on: {
      "load": _vm.onPreviewImageLoaded
    }
  }) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }